// extracted by mini-css-extract-plugin
export default {"beamerLists":"BeamerItems_beamerLists__8C1QQ","beamerDetails":"BeamerItems_beamerDetails__Mq5RP"};